import api from './baseApi';

export function getPublicLink(publicLink) {
  return api.get(`/validateTimesheet/${publicLink}`);
}

export function approveTimesheet(timesheet, publicLink, name) {
  return api.put(
    `/timesheets/${timesheet.company}/${timesheet.contractId}/${timesheet.timesheetId}/${publicLink}/approve`, name
  );
}

export function rejectTimesheet(timesheet, publicLink, rejectionReason) {
  return api.put(
    `/timesheets/${timesheet.company}/${timesheet.contractId}/${timesheet.timesheetId}/${publicLink}/reject`,
    rejectionReason
  );
}
